var React = require('react');

function CurveInline (props) {
    return React.createElement("svg",props,React.createElement("defs",null,[React.createElement("clipPath",{"id":"curve-outside","clipPathUnits":"objectBoundingBox","transform":"scale(0.000625 0.01)","key":0},React.createElement("path",{"d":"M0,50c0,0,350,50,800,50s800-50,800-50V0H0V50z"})),React.createElement("clipPath",{"id":"curve-inside","clipPathUnits":"objectBoundingBox","transform":"scale(0.000625 0.01)","key":1},React.createElement("path",{"d":"M800,50C350,50,0,0,0,0v100h1600V0C1600,0,1250,50,800,50z"}))]));
}

CurveInline.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 1600 100","width":"0","height":"0","style":{"position":"absolute"}};

module.exports = CurveInline;

CurveInline.default = CurveInline;
